<template>
  <div class="flex flex-wrap mt-2 sm:px-6 main">
    <loading-container
      :loading="loading"
      :error-loading="errorLoading"
      :loaded="!loading && !errorLoading"
      :retry="loadData"
    >
      <div class="booking-sec">
        <div class="route-sec">
          <div class="rts">
            <routes-container
              :routes="routes"
              :cities="cities"
              :selected-city="selectedCityId"
              @selected-city="setSelectedCityRoute"
              @show-itinerary="itineraryState"
              @next-page="showNextPage"
              @previous-page="showPreviousPage"
              v-if="!itinerary_state"
            />
            <template v-if="itinerary_state">
              <template v-if="itinerary_data.length === 0">
                <div class="flex flex-col items-center justify-center lg:py-20">
                  <img
                    src="@/assets/img/something-went-wrong.svg"
                    alt="No transactions"
                  />
                  <div class="mt-4 text-xs font-medium text-dark-type-4">
                    No route locations available for this route at the moment,
                    please choose a different route.
                  </div>
                  <button
                    class="
                      block
                      w-56
                      py-4
                      mt-10
                      font-bold
                      text-center text-white
                      rounded
                      bg-active
                    "
                    @click="back"
                  >
                    Go back
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="itinerary_scope">
                  <div
                    class="itinerary_sec"
                    :class="itineraryChoice ? 'displayNone' : ''"
                  >
                    <div class="svg_div">
                      <svg
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:cc="http://web.resource.org/cc/"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:dc="http://purl.org/dc/elements/1.1/"
                        xmlns:svg="http://www.w3.org/2000/svg"
                        style="height: 20px; width: 50px"
                        id="svg1878"
                        viewBox="0 0 23.846 36.653"
                        version="1.0"
                      >
                        <defs id="defs3">
                          <linearGradient
                            id="linearGradient2785"
                            x1="-579"
                            gradientUnits="userSpaceOnUse"
                            y1="-246.08"
                            gradientTransform="matrix(-.80139 0 0 -1.2478 -11.991 4.6899)"
                            x2="-559.4"
                            y2="-267.71"
                          >
                            <stop
                              id="stop11464"
                              stop-color="#80ff26"
                              offset="0"
                            />
                            <stop
                              id="stop11466"
                              stop-color="#2c9600"
                              offset="1"
                            />
                          </linearGradient>
                        </defs>
                        <g id="layer1" transform="translate(-432.1 -307.21)">
                          <path
                            id="path9831"
                            stroke-linejoin="round"
                            style="color: #000000; height: 100px; width: 100px"
                            d="m450.5 342.99l4.57-4.56-12.93-12.94 12.8-12.8-4.6-4.6-17.37 17.37 17.53 17.53z"
                            stroke="#116b1c"
                            stroke-linecap="round"
                            stroke-width="1.75"
                            fill="url(#linearGradient2785)"
                          />
                        </g>
                      </svg>
                      <button @click="back" class="bk_btn">Back</button>
                    </div>
                    <div class="px-4 py-4 bg-gray-type-4">
                      <div class="text-sm font-bold text-dark-type-3">
                        Choose a preferred time
                      </div>
                    </div>
                    <div class="bg-white">
                      <div
                        style="position: relative; cursor: pointer"
                        v-for="(route, index) in itinerary_data"
                        :key="index"
                        class="block pt-4 border-b border-gray-type-2 each__"
                        @click="itinerarySelected(route)"
                      >
                        <div class="flex justify-between px-4">
                          <div class="flex">
                            <div>
                              <div class="text-sm font-bold text-dark-type-3">
                                {{ route.pickup }}
                              </div>
                            </div>
                            <div class="ml-6 arrow_">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="12"
                              >
                                <g
                                  fill="none"
                                  fill-rule="evenodd"
                                  transform="translate(-2 -4)"
                                >
                                  <circle cx="10" cy="10" r="10" fill="none" />
                                  <path
                                    d="M3.333 10H15m-4.167-4.167L15 10l-4.167 4.166"
                                    stroke="#737D78"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                </g>
                              </svg>
                            </div>
                            <div class="ml-6">
                              <div class="text-sm font-bold text-dark-type-3">
                                {{ route.departure_time
                                }}{{ route.time_of_day }}
                              </div>
                              <!-- <div class="font-medium text-xxs text-dark-type-4">
                          VGC
                        </div> -->
                            </div>
                          </div>
                          <div class="flex">
                            <div>
                              <div class="font-bold text-dark-type-3">
                                &#8358; {{ route.fare }}
                              </div>
                              <div
                                class="
                                  font-bold
                                  text-right text-xxs text-dark-type-3
                                "
                              >
                                Bus
                              </div>
                            </div>
                            <div class="ml-2">
                              <label class="inline-flex">
                                <input
                                  type="radio"
                                  name="selected-itinerary"
                                  :value="route.id"
                                  :checked="
                                    selectedItinerary
                                      ? route.busStopId ===
                                        selectedItinerary.busStopId
                                      : false
                                  "
                                  id="itinerary-checkbox"
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="px-4 -mt-1">
                          <span class="font-medium text-xxs text-dark-type-4">
                            <font-awesome-icon
                              v-if="route.is_future_route"
                              icon="flag"
                              :style="{ color: '#ffb500' }"
                            />
                            {{ routeName }}
                          </span>
                        </div>
                        <div class="flex justify-between mt-4">
                          <div class="flex px-4 py-2">
                            <div class="hidden ml-6">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                              >
                                <g fill="none" fill-rule="evenodd">
                                  <circle cx="6" cy="6" r="6" fill="#131615" />
                                  <path
                                    fill="#FFF"
                                    fill-rule="nonzero"
                                    d="M8.86 8.603v-.429h.43v-2.23l-.354-2.487H4.64l-.353 2.487v2.23h.429v.43H3.258v-3.89h.214a.43.43 0 00.429-.429V3.43A.43.43 0 003.472 3h-.643v5.603H2.4v.429h7.318v-.429h-.857zM5.002 6.96a.429.429 0 11.858.002.429.429 0 01-.858-.002zm3.002 1.644h-2.43v-.429h2.43v.43zm.143-1.215a.429.429 0 110-.86.429.429 0 010 .861zM4.748 5.744l.264-1.858h3.552l.264 1.858h-4.08z"
                                  />
                                </g>
                              </svg>
                              <div
                                class="
                                  hidden
                                  ml-1
                                  font-medium
                                  text-dark-type-3 text-xxs
                                "
                              >
                                3 bus stops in route
                              </div>
                            </div>
                          </div>
                          <div class="flex px-4 py-2 bg-gray-type-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                            >
                              <g fill="#131615">
                                <path
                                  d="M1.64 7.217V5.249a.328.328 0 000-.656c-.905 0-1.64.736-1.64 1.64v.656c0 .542.442.984.984.984h.656a.328.328 0 000-.656zm12.466-2.624a.328.328 0 000 .656v1.968a.328.328 0 000 .656h.656a.986.986 0 00.984-.984v-.656c0-.904-.735-1.64-1.64-1.64zm-8.529 9.185a.328.328 0 00-.328.328H3.28a.328.328 0 00-.656 0v.656c0 .542.442.984.984.984h1.313a.986.986 0 00.984-.984v-.656a.328.328 0 00-.328-.328zm7.217 0a.328.328 0 00-.328.328h-1.969a.328.328 0 00-.656 0v.656c0 .542.442.984.984.984h1.313a.986.986 0 00.984-.984v-.656a.328.328 0 00-.328-.328z"
                                />
                                <path
                                  d="M12.794 0H2.952c-.904 0-1.64.736-1.64 1.64v11.154c0 .904.736 1.64 1.64 1.64h9.842c.904 0 1.64-.736 1.64-1.64V1.64c0-.904-.736-1.64-1.64-1.64zm-8.53 1.312h7.218a.985.985 0 010 1.968H4.265a.985.985 0 01-.985-.984c0-.542.442-.984.985-.984zm0 11.154a.986.986 0 01-.984-.985c0-.542.442-.984.985-.984.542 0 .984.442.984.984a.986.986 0 01-.984.985zm7.217 0a.986.986 0 01-.984-.985c0-.542.442-.984.984-.984.543 0 .985.442.985.984a.986.986 0 01-.985.985zm1.64-4.265c0 .543-.44.984-.983.984h-8.53a.985.985 0 01-.984-.984v-3.28c0-.543.442-.984.984-.984h8.53c.542 0 .984.441.984.984V8.2z"
                                />
                              </g>
                            </svg>
                            <div
                              class="
                                ml-1
                                font-bold
                                text-right text-xxs text-dark-type-3
                              "
                            >
                              Big Bus
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="map_sec">
                    <route-discovery
                      :class="`px-4 py-6 border rounded-md lg:max-w-sm-5 bg-secondary border-dark-type-2 selection min-width ${
                        itineraryChoice === true ? '' : 'disable-form'
                      }`"
                      :route-bus-stops="
                        busstop_data
                          ? busstop_data.filter((busstop) =>
                              selectedItinerary && selectedItinerary.id
                                ? busstop.id >= selectedItinerary.busStopId
                                : true
                            )
                          : []
                      "
                      :selected-itinerary="selectedItinerary"
                      @discovered="setRoutes"
                      @discovering="discovering = true"
                    >
                    </route-discovery>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <template v-if="discovered">
            <modal :show="showPayment" @close="showPayment = false">
              <payment-wizard
                :payment-information="paymentInformation"
                @payment-success="handlePaymentSuccess"
                @close="showPayment = false"
              ></payment-wizard>
            </modal>
          </template>
        </div>
      </div>
      <modal :show="showComingSoonModal" @close="showComingSoonModal = false">
        <route-notification
          @close="showComingSoonModal = false"
          @customer-notified="back"
          @schedule-booking="initiateScheduledBooking($event)"
          :title="routeAvailabilityTitle"
          :content="routeAvailabilityText"
          :route-details="currentSelectedRouteData"
        >
        </route-notification>
      </modal>

      <modal
        :show="showRouteAvailabilityModal"
        @close="showRouteAvailabilityModal = false"
      >
        <route-availability
          @close="showRouteAvailabilityModal = false"
          :title="routeAvailabilityTitle"
          :content="routeAvailabilityText"
        >
        </route-availability>
      </modal>
    </loading-container>
  </div>
</template>
<script>
import RoutesContainer from "@/components/RoutesContainer";
import axios from "@/services/axios";
import { mapGetters } from "vuex";
import RouteDiscovery from "@/components/discover-routes/RouteDiscovery";
import LoadingContainer from "../../components/LoadingContainer.vue";
import _ from "lodash";
import Modal from "@/components/Modal";
import PaymentWizard from "../../components/payment-wizard.vue";
import RouteNotification from "@/components/route-availability/route-notification";
import RouteAvailability from "@/components/route-availability/route-availability";
import routeValidator from "@/mixins/route-validator";
import { computeDiscountAmount } from "@/services/utils";

export default {
  components: {
    RouteAvailability,
    RouteNotification,
    RoutesContainer,
    RouteDiscovery,
    LoadingContainer,
    Modal,
    PaymentWizard,
  },
  mixins: [routeValidator],
  data() {
    return {
      selected: "",
      routes: [],
      city_id: null,
      cities: [],
      itinerary_state: false,
      itinerary_data: [],
      busstop_data: [],
      discovering: false,
      discovered: false,
      itineraryChoice: false,
      showPayment: false,
      routeName: null,
      itinerary_id: null,
      processing: false,
      itinerary_fare: 0,
      insufficentAmount: false,
      total: 0,
      walletBalance: 0,
      selectedRoute: null,
      selectedItinerary: null,
      routeOptions: {},
      route_id: null,
      paymentWallet: null,
      loading: true,
      errorLoading: false,
      selectedCityId: "",
      paymentData: null,
      paymentOption: "",
      showComingSoonModal: false,
      showRouteAvailabilityModal: false,
      routeAvailabilityTitle: "",
      routeAvailabilityText: "",
      currentSelectedRouteData: null,
      appliedDiscount: null,
    };
  },
  async created() {
    if (this.$route.query.options) {
      const routeData = Object.fromEntries(
        new URLSearchParams(this.$route.query.options)
      );

      this.itineraryState(routeData);
    }

    this.loadData();
  },
  computed: {
    ...mapGetters("app", ["wallet"]),
    ...mapGetters("auth", ["user"]),
    defaultCityId() {
      if (this.cities.length === 0) {
        return;
      }

      return this.cities.filter(($) => $.name === "Lagos")[0].city_id;
    },
    payableAmount() {
      return this.appliedDiscount
        ? this.total - this.appliedDiscount.discountAmount
        : this.total;
    },
    paymentInformation() {
      if (!this.paymentData) {
        return {};
      }

      return {
        ticketType: this.paymentData.ticket_type,
        passengers: this.paymentData.passengers,
        pricePerPassenger: this.paymentData.price_per_passenger,
        luggageCost: 0,
        total: parseFloat(this.paymentData.total),
        payableAmount: this.payableAmount,
        discountText: this.appliedDiscount?.discountText,
        processBooking: this.book,
      };
    },
  },
  methods: {
    async loadData(city_id = null) {
      this.loading = true;

      this.errorLoading = false;

      try {
        if (this.cities.length === 0) {
          await this.fetchSupportedCities();
        }

        if (this.cities.length) {
          this.selectedCityId = city_id || this.defaultCityId;

          await this.getRoutesByCities({
            city_id: this.selectedCityId,
          });
        }

        this.loading = false;
      } catch {
        this.errorLoading = true;
        this.loading = false;
      }
    },
    fetchSupportedCities() {
      return axios
        .get("city")
        .then((res) => {
          this.cities = res.data.data;
          return res.data.data;
        })
        .catch((ERR) => {
          console.log(ERR, "ERR");
        });
    },
    async getRoutesByCities(query) {
      const { limit = 50, page = 1, city_id } = query;
      return axios
        .get("routes", {
          params: {
            limit: limit,
            page: page,
            city_id: city_id,
            "fields[route]":
              "id,pickup,destination,city_id,route_availability_days,route_availability_start_date,route_availability_end_date",
            related: "",
          },
        })
        .then(async (res) => {
          this.routes = res.data;

          return res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async showPreviousPage(page) {
      const route = await this.getRoutesByCities({
        city_id: this.city_id,
        limit: 50,
        page,
      });
      this.routes = route;
    },
    async showNextPage(page) {
      const route = await this.getRoutesByCities({
        city_id: this.city_id,
        limit: 50,
        page,
      });
      this.routes = route;
    },
    validateSelectedRoute(route) {
      this.currentSelectedRouteData = {
        data: this.routeOptions.data,
        route,
      };
      let canProceed = true;
      this.validateRoute(
        route,
        {
          selectedDate: this.currentSelectedRouteData.data
            ? new Date(this.currentSelectedRouteData.data.departure_date)
            : null,
          tripType: "one-way",
          numberOfWeeks: null,
          selectedDays: null,
        },
        {
          availableInFuture: (routeData) => {
            this.routeAvailabilityTitle = `This route is coming soon`;
            this.routeAvailabilityText = `<div class="text-center"> <p>The selected route is only available from </p>
                                        <p class="font-bold">${
                                          routeData.route_availability_start_date
                                            ? new Date(
                                                routeData.route_availability_start_date
                                              ).toDateString()
                                            : "a date that will be communicated"
                                        }</p> </div>`;
            this.showComingSoonModal = true;
            canProceed = false;
          },
          notAvailable: (routeData, availableOnlyOnSelectDays) => {
            this.routeAvailabilityTitle = `Oops!`;
            this.routeAvailabilityText = `<div class="text-center"> <p>Sorry, this route is unavailable on the selected day. </p></div>`;
            if (availableOnlyOnSelectDays) {
              const selectedDays = route.route_availability_days
                ? JSON.parse(route.route_availability_days)
                : [];
              const selectedDaysString = selectedDays.join(", ");
              if (selectedDaysString) {
                this.routeAvailabilityText = `<div class="text-center"> <p>Sorry, this route is only available on the following days: </p>
                                        <p class="font-bold" style="text-transform: capitalize">${selectedDaysString}</p> </div>`;
              }
            }
            this.showRouteAvailabilityModal = true;
            canProceed = false;
          },
          available: () => {
            canProceed = true;
          },
        }
      );
      return canProceed;
    },
    initiateScheduledBooking(newDate, scheduleMode = true) {
      if (newDate) {
        this.routeOptions.data.departure_date = newDate;
      }
      this.isScheduleBooking = scheduleMode;
      if (this.isScheduleBooking) {
        this.maybeTriggerPaymentModal();
        this.paymentData = {
          total: this.total,
          ticket_type: this.routeOptions.data.route_type,
          price_per_passenger: this.itinerary_fare,
          passengers: 1,
        };
      }
    },
    async itineraryState(routeData) {
      this.routeName = routeData.pickup;
      this.route_id = routeData.id;

      this.loading = true;

      try {
        await this.fetchRouteItinerary(routeData.id);
        await this.fetchRouteBusstops(routeData.id);
      } catch {
        //
      } finally {
        this.loading = false;

        this.selectedRoute = routeData;
        this.itinerary_state = true;

        const urlParams = new URLSearchParams({
          ...routeData,
        }).toString();

        this.$router
          .push({
            query: { ...this.$route.query, options: urlParams },
          })
          .catch(() => {});
      }
    },
    fetchRouteItinerary(id) {
      return axios
        .get(`routes/${id}/itenaries`)
        .then((res) => {
          const data = res.data.data;
          this.itinerary_data = _.uniqBy(data, (i) =>
            [i.pickup, i.trip_time].join()
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },
    fetchRouteBusstops(routeId) {
      return axios
        .get(`routes/${routeId}/busstops`)
        .then((res) => {
          let data = res.data.data;
          data = data.map((stop) => ({ ...stop, label: stop.name }));
          this.busstop_data = data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    resetSelectionState() {
      this.itineraryChoice = false;
      this.itinerary_id = null;
      this.itinerary_fare = null;
      this.selectedItinerary = null;
      this.isScheduleBooking = false;
    },
    itinerarySelected(itinerary) {
      this.itineraryChoice = true;
      this.itinerary_id = itinerary.id;
      this.itinerary_fare = itinerary.fare;
      this.selectedItinerary = itinerary;
      this.isScheduleBooking = false;
      setTimeout(() => this.scrollToTop(), 1000);
    },
    setRoutes(routes) {
      this.discovered = true;
      this.total = this.paymentTotal(routes);
      this.paymentOption = routes.data.payment_option;

      this.routeOptions = routes;

      if (!this.itinerary_id) {
        return this.$toast.error(`Please select an Itinerary`);
      }

      this.isScheduleBooking = false;
      if (!this.isScheduleBooking) {
        const canProceed = this.validateSelectedRoute(this.selectedRoute);
        if (!canProceed) {
          return;
        }
      }
      this.maybeTriggerPaymentModal();

      this.paymentData = {
        total: this.total,
        ticket_type: routes.data.route_type,
        price_per_passenger: this.itinerary_fare,
        passengers: 1,
      };
    },
    async maybeTriggerPaymentModal() {
      if (!this.user) {
        return this.$router.push({
          name: "login",
          query: { redirect: this.$route.fullPath },
        });
      }

      // apply promo to booking payment
      const promoCodeData = await this.checkForPromoCode(this.user.id);
      this.appliedDiscount = promoCodeData ? promoCodeData : null;

      this.showPayment = true;
    },
    async checkForPromoCode(userId) {
      try {
        let promoCode = await axios
          .get(`users/${userId}/next-applicable-route-promo-code`)
          .then((res) => res?.data);
        if (promoCode) {
          promoCode = computeDiscountAmount(
            this.itinerary_fare,
            promoCode,
            this.paymentData.ticket_type
          );
        }
        return promoCode;
      } catch (e) {
        console.log(e);
        return null;
      }
    },

    async book(paymentInformation = null) {
      this.discovered = true;
      this.processing = true;

      const route = this.routeOptions.data;

      return axios.post(`/users/${this.user.id}/routes`, {
        route_id: this.route_id,
        itinerary_id: this.selectedItinerary.id,
        pickup_id: route.source_route.id,
        destination_id: route.destination_route.id,
        start_date: route.departure_date,
        end_date: this.getEndDate(route),
        days_ids: this.getDays(route),
        recurring: route.route_type === "subscription" ? true : false,
        meta: JSON.stringify(route),
        luggage_quantity: 1,
        payment_source: paymentInformation
          ? paymentInformation.paymentSource
          : this.$store.state.app.walletSource || "main_balance",
        payment_reference: paymentInformation?.paymentReference,
        pickup_route_bus_stop_id: route.source_route.id,
        destination_route_bus_stop_id: route.destination_route.id,
      });
    },
    handlePaymentSuccess(bookingResponse) {
      const data = bookingResponse.data;
      const localBookingState = {
        firstTripData: data,
      };
      this.$store.dispatch("app/updateLocalBookingData", localBookingState);
      this.$router.push({
        name: "dashboard.booking-successful",
        params: {
          bookingId: data ? data.id : null,
        },
      });
    },
    paymentTotal(routes) {
      routes = routes.data;
      if (this.itinerary_fare >= 0) {
        let total;
        if (routes.route_type === "subscription") {
          total =
            this.itinerary_fare *
            routes.trip_days.length *
            routes.subscription_duration;
        } else {
          total = this.itinerary_fare;
        }
        return total;
      }
      return this.$toast.error("An error occurred. Please try again.");
    },
    getEndDate(route) {
      if (route.route_type === "subscription") {
        let _date = this.$moment(route.departure_date).add(
          route.subscription_duration,
          "weeks"
        );
        return _date.subtract(1, "days").format("YYYY-MM-DD");
      }

      return route.departure_date;
    },
    getDays(route) {
      if (route.route_type === "subscription") {
        return route.trip_days;
      }
      return [this.$moment(route.departure_date).day() + 1];
    },
    async setSelectedCityRoute(id) {
      this.selectedCityId = id;

      this.loadData(this.selectedCityId);
    },
    back() {
      this.resetSelectionState();
    },
    addQueryParams(query) {
      // const path = this.user ? this.$route.name : "login";
      const path = this.$route.name;
      const urlParams = new URLSearchParams(query).toString();

      if (this.$route.name !== "home") {
        this.$router
          .push({
            name: path,
            query: { ...this.$route.query, options: urlParams },
          })
          .catch(() => {});
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.booking-sec {
  width: 90%;
  min-height: 600px;
  height: fit-content;
  display: flex;
  flex-flow: row;
  margin: auto;
}
.city-side {
  width: 20%;
  height: 100%;
  background: #f8f8f8;
}
.modal-title {
  font-size: 14px;
  margin-left: 30px;
}
.route-sec {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  position: relative;
}
.selection {
  border-radius: 5px;
  outline: none;
}
.route-label {
  color: #01e069;
  font-weight: bold;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.rts {
  margin: 3% 2%;
  height: 100%;
}
.itinerary_scope {
  height: 100%;
  width: 100%;
  max-width: 871px;
  margin: 0 auto;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.itinerary_sec {
  width: 45%;
  /* border: 1px solid #F2F2F2; */
  height: 100%;
}
.svg_div {
  display: flex;
  flex-flow: row;
  border: 1px solid #f2f2f2;
  width: 25%;
  border-radius: 5px;
  margin-bottom: 5%;
  height: 30px;
  align-items: center;
}
.bk_btn {
  text-align: center;
  margin-top: 4%;
  margin-left: -6%;
  outline: none;
}
each__ {
  margin-top: 20px;
}
.cursor-pointer {
  cursor: pointer;
}
.map_sec {
  margin-top: 49.7px;
  height: 100%;
}
.map_text {
  font-weight: bold;
  margin-top: 50%;
  text-align: center;
  font-size: 20px;
}
.arrow_ {
  margin-left: 1rem;
}
.selection {
  margin: auto;
}
.pad-select {
  padding: 6px 0;
}
.disable-form {
  pointer-events: none;
  opacity: 0.7;
}
.min-width {
  min-width: 400px;
}

@media screen and (max-width: 768px) {
  .booking-sec {
    flex-flow: column;
  }
  .city-side {
    width: 100%;
    height: 50%;
  }
  .form_ {
    margin-top: unset;
  }
  .city_label {
    margin-top: 15%;
  }
  .route-sec {
    width: 100%;
  }
  .itinerary_scope {
    flex-flow: column;
  }
  .itinerary_sec {
    width: 100%;
  }
  .displayNone {
    display: none;
  }
  .map_sec {
    width: 100%;
  }
  .map_text {
    display: none;
  }
  .svg_div {
    width: 35%;
  }
  .min-width {
    min-width: 200px;
  }
}

@media only screen and (max-width: 1024px) and (min-width: 767px) {
  .svg_div {
    width: 30%;
  }
}

@media only screen and (max-width: 768px) and (min-width: 426px) {
  .svg_div {
    width: 20%;
  }
}
</style>